import { render } from "./WordComponent.vue?vue&type=template&id=4a2fe6a6&scoped=true"
import script from "./WordComponent.vue?vue&type=script&lang=js"
export * from "./WordComponent.vue?vue&type=script&lang=js"

import "./WordComponent.vue?vue&type=style&index=0&id=4a2fe6a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2fe6a6"]])

export default __exports__